import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/layout';
import SEO from '../components/seo';
import LauncherSignUp from '../components/LauncherSignUp';
import setLang from '../utils/setLang';

const seoKeywords = [
  'ncsoft', 'register', 'sign up', 'create account',
];

const Main = (props) => {
  const { pageContext, location } = props;

  let currentGame = null;
  if (location.state) currentGame = location.state.currentGame;

  const [ gameState, setGameState ] = useState(currentGame);

  useEffect(() => {
    window.scrollTo(0, 0);
    const { data: { languageMapping }, language } = pageContext;
    setLang(languageMapping[language]);
  });

  return (
    <Layout>
      <SEO title="Sign Up" keywords={seoKeywords} />
      <LauncherSignUp
        lang={pageContext.language}
        path={props}
        global={pageContext}
        game={gameState}
        setGame={setGameState}
      />
    </Layout>
  );
};

Main.propTypes = {
  pageContext: PropTypes.object.isRequired,
};

export default Main
